import { render } from "./ContentHeader.vue?vue&type=template&id=130aeca0&scoped=true"
import script from "./ContentHeader.vue?vue&type=script&lang=js"
export * from "./ContentHeader.vue?vue&type=script&lang=js"

import "./ContentHeader.vue?vue&type=style&index=0&id=130aeca0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4192554447/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130aeca0"]])

export default __exports__